import React from 'react'
import { Translation } from 'react-i18next'
import { Translate, TranslateProps } from 'react-localize-redux'

type Props = TranslateProps

const CustomTranslate = ({ id, children }: Props): JSX.Element => {
    console.log('inside i18next Translate')
    // Here we can replace Translate with whatever we want
    return (
        <>
            <Translation>{(t) => <>{t(id)}</>}</Translation>
            <Translate id={id}>{children}</Translate>
        </>
    )
}

export default CustomTranslate
